import React from 'react';
import ResultLink from './ResultLink';
import { Result } from '@coveo/headless';

interface NewsResultCardProps {
  result: Result;
  newsType: string;
  title: string;
  date: string;
  url: string;
}

const NewsResultCard: React.FC<NewsResultCardProps> = ({
  result,
  newsType,
  title,
  date,
  url,
}) => {
  // Don't render the card if newsType is undefined
  if (newsType === 'undefined' || newsType === undefined || !newsType) {
    return null;
  }

  return (
    <ResultLink result={result} href={url} className="news-result-card">
      <div className="news-result-card__type">{newsType}</div>
      <h3 className="news-result-card__title">{title}</h3>
      <p className="news-result-card__date">{date}</p>
    </ResultLink>
  );
};

export default NewsResultCard;
